<script setup lang="ts">
import favicon from '~/assets/images/favicon/favicon.svg'

const { initWallet } = useConnectModal()

useHead({
  title: import.meta.env.VITE_APP_TITLE,
  meta: [
    { name: 'description', content: import.meta.env.VITE_APP_DESCRIPTION },
    { name: 'keywords', content: import.meta.env.VITE_APP_KEYWORDS },
  ],
  link: [
    {
      rel: 'icon',
      type: 'image/svg+xml',
      href: favicon,
    },
  ],
})
</script>

<template>
  <router-view />
</template>